var map = {
	"./goldcoin/pop-coin-hero-icon-0.png": 22785,
	"./memetown/pop-coin-hero-icon-0.png": 72004,
	"./reflection/pop-coin-hero-icon-0.png": 30563,
	"./tapcoin/pop-coin-hero-icon-0.png": 63230
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18662;